import { map, get, isEmpty, pick } from 'lodash';

import algoliaApi from '../services/algolia-api';

export const getActiveFilters = filters =>
  filters
    .filter(({ value }) => !isEmpty(value))
    .map(f =>
      pick(f, ['value', 'id', 'isAsync', 'isMulti', 'label', 'title', 'value'])
    );

export const segmentFilters = [
  {
    section: 'Content',
    id: 'show',
    title: 'Show',
    allowBulk: true,
    bulkRequest: algoliaApi.getBulkShowsByName,
    description:
      'Segment your users by the shows they watch. You may select multiple.'
  },
  {
    section: 'Content',
    id: 'movie',
    title: 'Movie',
    allowBulk: true,
    bulkRequest: algoliaApi.getBulkMoviesByName,
    description:
      'Segment your users by the movies they watch. You may select multiple.'
  },
  {
    section: 'Content',
    id: 'network',
    title: 'Originating Network',
    description:
      'Segment your users by the networks they watch. You may select multiple.'
  },
  {
    section: 'Content',
    id: 'platform',
    title: 'Platform',
    description: 'Segment your users by platform.'
  },
  {
    section: 'Content',
    id: 'studio',
    title: 'Studio',
    description:
      'Segment your users by the studios they watch. You may select multiple.'
  },
  {
    section: 'Content',
    id: 'originating_country',
    title: 'Originating Country',
    description: ''
  },
  {
    section: 'Content',
    id: 'language',
    title: 'Originating Language',
    description: ''
  },
  {
    section: 'Content',
    id: 'runtime',
    title: 'Runtime',
    description: 'Segment your shows by runtime.'
  },
  {
    section: 'Content',
    id: 'status',
    title: 'Status',
    description: 'Segment your shows by status.'
  },
  {
    section: 'Content',
    id: 'genre',
    title: 'Genre',
    description: 'Segment your shows by their age group.'
  },
  {
    section: 'Content',
    id: 'release_date',
    title: 'Release Date',
    description: 'Segment your shows by release date.'
  },
  {
    section: 'Demographics',
    id: 'age',
    title: 'Age',
    description:
      'Segment your users by their age group. You may select multiple.'
  },
  {
    section: 'Demographics',
    id: 'gender',
    title: 'Gender',
    description: 'Segment your users by their gender.'
  },
  {
    section: 'Demographics',
    id: 'country',
    title: 'Country',
    description: 'Segment the country they live in. You may select multiple.'
  },
  {
    section: 'Demographics',
    id: 'panel',
    description: 'Sample balance users. US only.',
    label: 'Panel',
    options: [
      { value: 'Balanced', label: 'Balanced' },
      { value: 'Total', label: 'Total' }
    ],
    title: 'Panel'
  },
  {
    section: 'Date',
    id: 'date',
    title: 'Date',
    description: 'Segment your shows by date.'
  },
  {
    section: 'Date',
    id: 'first_release_date',
    title: 'First Release Date',
    description: 'Segment your shows by first release date.'
  }
];

export const formatFilters = config =>
  map(segmentFilters, filter => {
    const { value, ...configExceptValue } = get(config, [filter.id], {});
    return { ...filter, ...configExceptValue };
  });

export default { formatFilters, segmentFilters };
